const handleStatusApproved = (data) => {
    const card = document.querySelector('[data-card="status-approved"]');
    card.querySelector('[data-order-id]').textContent = data.art_id;

    let imageList = '';
    let downloadList = '';

    data.png.forEach((image, index) => {
        if (image.thumbnails) {
            imageList += `
                <li class="">
                    <a href="${image.url}" data-fancybox="gallery" style="cursor: zoom-in;">
                        <img src="${image.thumbnails.large.url}" alt="" class="img-fluid">
                    </a>
                </li>
            `;
        } else {
            imageList += `
                <li class="">
                    <a href="${image.url}" data-fancybox="gallery" style="cursor: zoom-in;">
                        <img src="${image.url}" alt="" class="img-fluid">
                    </a>
                </li>
            `;
        }
        downloadList += `
            <li>
                <a class="dropdown-item d-flex align-items-center" href="${image.url}">
                    PNG ${index + 1}
                </a>
            </li>
        `;
    });

    data.jpg.forEach((image, index) => {
        downloadList += `
            <li>
                <a class="dropdown-item d-flex align-items-center" href="${image.url}">
                    JPG ${index + 1}
                </a>
            </li>
        `;
    });

    // Handle Illustrator download links (single or multiple)
    if (Array.isArray(data.ai)) {
        data.ai.forEach((aiUrl, index) => {
            downloadList += `
                <li>
                    <a class="dropdown-item d-flex align-items-center" href="${aiUrl}" target="_blank">
                        Illustrator ${index + 1}
                    </a>
                </li>
            `;
        });
    } else if (typeof data.ai === 'string' && data.ai.includes(',')) {
        // Comma-separated string
        data.ai.split(',').forEach((aiUrl, index) => {
            downloadList += `
                <li>
                    <a class="dropdown-item d-flex align-items-center" href="${aiUrl.trim()}" target="_blank">
                        Illustrator ${index + 1}
                    </a>
                </li>
            `;
        });
    } else if (data.ai) {
        // Single link
        downloadList += `
            <li>
                <a class="dropdown-item d-flex align-items-center" href="${data.ai}" target="_blank">
                    Illustrator
                </a>
            </li>
        `;
    }

    card.querySelector('[data-images-list]').insertAdjacentHTML('afterbegin', imageList);
    card.querySelector('[data-download-list]').insertAdjacentHTML('afterbegin', downloadList);
    card.style.display = 'block';

    document.querySelectorAll('.btn-artwork-modal-understand').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            setTimeout(() => {
                const modal = bootstrap.Modal.getOrCreateInstance('#artwork-review-edit-form-modal')
                modal.show()
            }, 250)
        })
    })
};

const handleOutForRevision = (data) => {
    const card = document.querySelector('[data-card="status-out-for-revision"]');
    card.querySelector('[data-order-id]').textContent = data.art_id;

    card.style.display = 'block';
};

const handleRevisionSent = (data) => {
    const card = document.querySelector('[data-card="status-revision-sent"]');
    card.querySelector('[data-order-id]').textContent = data.art_id;

    let imageList = '';

    data.png.forEach((image) => {
        if (image.thumbnails) {
            imageList += `
                <li class="">
                    <a href="${image.url}" data-fancybox="gallery" style="cursor: zoom-in;">
                        <img src="${image.thumbnails.large.url}" alt="" class="img-fluid">
                    </a>
                </li>
            `;
        } else {
            imageList += `
                <li class="">
                    <a href="${image.url}" data-fancybox="gallery" style="cursor: zoom-in;">
                        <img src="${image.url}" alt="" class="img-fluid">
                    </a>
                </li>
            `;
        }
    });

    card.querySelector('[data-images-list]').insertAdjacentHTML('afterbegin', imageList);
    card.style.display = 'block';
};

const handleOutForDesign = (data) => {
    const card = document.querySelector('[data-card="status-out-for-design"]');
    card.querySelector('[data-order-id]').textContent = data.art_id;

    card.style.display = 'block';
};

const handleWaitingForImage = (data) => {
    const card = document.querySelector('[data-card="status-waiting-for-image"]');
    card.querySelector('[data-order-id]').textContent = data.art_id;

    card.style.display = 'block';
};

const handleCancelled = (data) => {
    const card = document.querySelector('[data-card="status-cancelled"]');
    card.querySelector('[data-order-id]').textContent = data.art_id;

    card.style.display = 'block';
};

const init = async () => {
    let order = ''
    //const urlParams = new URLSearchParams(window.location.search);
    //detect button click get value from input  artwork-review-email
    const orderLookupForm = document.querySelector('#artwork-review-order-lookup-form');
    //const email = document.querySelector('#artwork-review-email').value;
    order = document.querySelector('#artwork-review-ordernumber').value;

    // const order = document.getElementById('artwork-review-email').value
    //const statusParam = urlParams.get('status');

    if (!order) {
        console.log(order)
        document.querySelector('#artwork-review-error').style.display = 'block';
        return;
    }

    document.querySelector('#artwork-review-loading').style.display = 'flex';

    const response = await fetch(`https://oms.thecustomcaptain.com/search?query=${order}`);
    let data = await response.json();

    document.querySelector('#artwork-review-loading').style.display = 'none';
    orderLookupForm.style.display = 'none';
    if (data.length === 0) {
        document.querySelector('#artwork-review-error').style.display = 'block';
        return;
    }

    data = data[0];

    let artwork_status = data.artwork_status;

    // if (statusParam) {
    //     artworkstatus = statusParam.toString();
    // }

    // console.log(statusParam);

    switch (artwork_status) {
        case 'customer_approved':
        case 'complete':
            handleStatusApproved(data);
            break;
        case 'edits_requested':
        case 'needs_more_information':
            handleOutForRevision(data);
            break;
        case 'sent_to_customer':
            handleRevisionSent(data);
            break;
        case 'submitted':
        case 'submitted_quality_issue':
        case 'ready_for_design':
        case 'out_for_design':
        case 'design_received':
            handleOutForDesign(data);
            break;
        case 'Bad Photo':
        case 'Requested Photo via Form':
            handleWaitingForImage(data);
            break;
        case 'cancelled':
            handleCancelled(data);
            break;
        default:
            console.log('error reading status ' + artwork_status);
    }

    const editScript = document.getElementById('miniextensions-iframe-embed-edit').src = data.edit_submission;
    const approveScript = document.getElementById('miniextensions-iframe-embed-approve').src = data.approve_submission;

    window.localStorage.setItem('artwork-order-id', data.art_id)

};
const submitBtn = document.querySelector('#artwork-review-submit');

document.querySelector('#artwork-review-edit-form-modal, #artwork-review-approve-form-modal').addEventListener('hidden.bs.modal', () => {
    window.location.reload();
});
submitBtn.addEventListener('click', (e) => {
    init();
});